// extracted by mini-css-extract-plugin
export default {"formContainer":"styles__formContainer___2NkqU"};